<template>
  <img :src="getImageFromContent(content)" class="image-max" @click="imageClick(content)" alt="" @load="imgLoaded">
</template>

<script>
// import util from 'util/'

export default {
  name: 'message_photo',
  props: {
    content: String,
    isLastIndex: Boolean
  },
  methods: {
    getImageFromContent (content) {
      const jsonContent = JSON.parse(content)
      return jsonContent.url
      /*
      if (util.isMobile()) {
        return jsonContent.mobile
      } else {
        return jsonContent.web
      }
      */
    },
    imageClick (content) {
      const jsonContent = JSON.parse(content)
      return window.open(jsonContent.url, 'imageWindow', 'toolbar=no,menubar=no,resizeable=1,width=800,height=800')
    },
    imgLoaded () {
      if (this.isLastIndex) {
        this.$eventBus.$emit('setScrollToEnd', true)
      }
    }
  }
}
</script>

<style scoped>
  .image-max {
    max-width: 240px;
    cursor: zoom-in;
  }
</style>



// WEBPACK FOOTER //
// src/components/webchat/message/fragments/message_photo.vue